module.exports = __webpack_public_path__ + "assets/img/cd3e-tt.svg";